<template
  ><transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h1>Join Slow Band</h1>
            </slot>
          </div>

          <div class="modal-body">
            <div v-if="(authTwit === true) & (errorState === false)">
              <slot name="body">
                <img class="twitter_photo" :src="twitter_user.photoURL" />
                <p>{{ twitter_user.displayName }}, you're almost done!</p>
                <p>This is what membership provides:</p>
                <ul>
                  <li>You can save your contrasts</li>
                  <li>
                    You can choose which contrasts you share or remain private
                  </li>
                  <li>You get connected to the community of Slow Band</li>
                  <li>
                    You get the opportunity to support this project (involvement
                    or financial)
                  </li>
                </ul>
                <div class="signUpForm">
                  <ValidationProvider
                    rules="secret|required"
                    v-slot="{ errors }"
                  >
                    <label>username:</label>
                    <br />
                    <input
                      type="text"
                      v-model="signUpUserName"
                      placeholder="minimum of 6 characters"
                    />
                    <br />
                    <span class="error"
                      ><em>{{ errors[0] }}</em></span
                    >
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ errors }">
                    <label>first name:</label>
                    <br />
                    <input
                      type="text"
                      v-model="signUpFirstName"
                      placeholder="nicknames are fine"
                    />
                    <br />
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ errors }">
                    <label>last name:</label>
                    <br />
                    <input
                      type="text"
                      v-model="signUpLastName"
                      placeholder="last name"
                    />
                    <br />
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <label>email:</label>
                    <br />
                    <input
                      type="text"
                      v-model="signUpEmail"
                      placeholder="valid email required"
                    />
                    <br />
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <div class="privacy">
                      <input
                        class="privacy"
                        id="privacy"
                        type="checkbox"
                        v-model="signUpPrivacy"
                      />
                      <label class="privacy" for="privacy"
                        >Please review our
                        <a href="/privacy" target="_blank"
                          >privacy policy</a
                        ></label
                      >
                    </div>
                    <span class="error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <p style="font-size: 12px;">
                    <em>
                      once signed in, you can add more information about
                      yourself in the profile section</em
                    >
                  </p>
                </div>
              </slot>
              <div class="modal-footer">
                <slot name="footer">
                  <!-- <p></p> -->
                  <!-- <div class="actionSection"> -->
                  <button class="signup_button" @click="saveUser">
                    Sign Up
                  </button>
                  &nbsp;
                  <button class="signup_button" @click.prevent="passOnSignUp">
                    Sign Up Later
                  </button>
                  &nbsp;
                  <button class="signup_button" @click="close">Cancel</button>
                  <!-- </div> -->
                </slot>
              </div>
            </div>
            <div v-else-if="errorState === false">
              <slot name="body">
                <div class="entryLevel">
                  <p>
                    Currently this app uses Twitter authentication to verify
                    it's members. Sign up is easy and secure.
                  </p>
                </div>
              </slot>
              <div class="modal-footer">
                <slot name="footer">
                  <br />
                  <button class="twitter_sign_up" @click.prevent="signin">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      role="img"
                      class="twitter_icon"
                    >
                      <path
                        d="M22.162 5.656a8.383 8.383 0 01-2.402.658A4.196 4.196 0 0021.6 4c-.82.488-1.719.83-2.656 1.015a4.182 4.182 0 00-7.126 3.814 11.874 11.874 0 01-8.62-4.37 4.168 4.168 0 00-.566 2.103c0 1.45.738 2.731 1.86 3.481a4.168 4.168 0 01-1.894-.523v.052a4.185 4.185 0 003.355 4.101 4.211 4.211 0 01-1.89.072A4.185 4.185 0 007.97 16.65a8.395 8.395 0 01-6.191 1.732 11.83 11.83 0 006.41 1.88c7.693 0 11.9-6.373 11.9-11.9 0-.18-.005-.362-.013-.54a8.495 8.495 0 002.087-2.165l-.001-.001z"
                        fill="#ffffff"
                      ></path>
                    </svg>
                    Continue with Twitter
                  </button>
                  <br />
                  <button @click="close">Cancel</button>
                </slot>
              </div>
            </div>
            <div v-else>
              We encountered errors during sign up. Please review and try again
              <slot name="body">
                <p>{{ errorMessage }}</p>
                <br />
                <button @click="close">Close</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import gql from "graphql-tag";
import { onLogin } from "../../vue-apollo.js";

extend("secret", {
  validate: value => value.length >= 6,
  message: "minimum of 6 characters needed"
});
extend("required", {
  ...required,
  message: "this field is required"
});
extend("email", {
  ...email,
  message: "please enter a valid email"
});
extend("minlength", {
  validate: value => value.length > 1,
  message: "a value is needed"
});

export default {
  name: "sign_up_modal",
  components: {
    ValidationProvider
  },
  data() {
    return {
      signUpUserName: "",
      signUpFirstName: "",
      signUpLastName: "",
      signUpEmail: "",
      signUpPrivacy: false,
      twitterUserName: "",
      twitterToken: null,
      twitterId: "",
      twitterImage: null,
      hasuraId: "",
      errorState: false,
      errorMessage: ""
    };
  },
  computed: {
    ...mapGetters([
      "getSignedIn",
      "getUser",
      "getToken",
      "getHasuraId",
      "getUserSignedUp"
    ]),
    tested() {
      return false;
    },
    authTwit() {
      if (this.getToken !== null) {
        return true;
      } else {
        return false;
      }
    },
    notSignedUp() {
      if (this.getUserSignedUp === false) {
        return true;
      } else {
        return false;
      }
    },
    twitter_user() {
      this.setUser();
      return this.getUser.user.providerData[0];
    }
  },
  methods: {
    ...mapActions(["showSignUpModal", "signIn", "setSignInState"]),
    close() {
      this.showSignUpModal(false);
    },
    signin() {
      let self = this;
      this.signIn().then(async attempt => {
        if (attempt) {
          self.twitterToken = self.getToken;
          self.twitterId = self.getUser.user.providerData[0].uid;
          self.twitterUserName = self.getUser.user.providerData[0].displayName;
          self.twitterImage = self.getUser.user.providerData[0].photoURL;
          self.hasuraId = self.getHasuraId;
        } //add error handling here
      });
    },
    saveUser() {
      let credat = new Date();
      let self = this;
      console.log(self.hasuraId);
      let test = this.getHasuraId;
      console.log(test);
      //now insert user in hasura
      onLogin(this.$apolloProvider.defaultClient, self.twitterToken).then(
        async () => {
          try {
            let user_exists = await this.$apollo.mutate({
              mutation: gql`
                mutation addUser($object: users_insert_input!) {
                  insert_users_one(object: $object) {
                    user_email
                    twitter_id
                    last_name
                    first_name
                    user_id
                    date_created
                    username
                  }
                }
              `,
              variables: {
                object: {
                  user_id: self.hasuraId,
                  user_email: self.signUpEmail,
                  twitter_id: self.twitterId,
                  last_name: self.signUpLastName,
                  first_name: self.signUpFirstName,
                  date_created: credat,
                  username: self.signUpUserName
                }
              }
            });
            console.log(user_exists);
            self.setSignInState(true);
            self.$router.push("Recent");
            this.showSignUpModal(false);
          } catch (e) {
            self.errorMessage = JSON.stringify(e.message);
            self.errorState = true;
          }
          // if (user_exists.data.users_aggregate.aggregate.count > 0) {
          //     self.$router.push("Recent");
          // } else {
          //     self.showSignUpModal(true);
          // }
        }
      );
    },
    setUser() {
      this.twitterToken = this.getToken;
      this.twitterId = this.getUser.user.providerData[0].uid;
      this.twitterUserName = this.getUser.user.providerData[0].displayName;
      this.twitterImage = this.getUser.user.providerData[0].photoURL;
      this.hasuraId = this.getHasuraId;
    },
    passOnSignUp() {
      this.setSignInState(true);
      this.showSignUpModal(false);
    }
  }
};
</script>

<style lang="sass">
.modal-mask
  position: fixed
  z-index: 9998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.5)
  display: table
  transition: opacity 0.3s ease


.modal-wrapper
  display: table-cell
  vertical-align: middle


.modal-container
  display: grid
  width: 350px
  grid-template-columns: 1fr 2fr 1fr
  grid-template-rows: 70px 3fr 1fr
  grid-template-areas: "section section section section" "section1 section1 section1 section1" "section2 section2 section2 section2"
  margin: 0px auto
  padding: 20px 30px
  background-color: #fff
  border-radius: 2px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33)
  transition: all 0.3s ease
  max-height: 550px;
  overflow-y: scroll;


.modal-header h3
  margin-top: 0
  color: #42b983

.modal-header
  grid-area: section
  text-align: center !important
  grid-row: 1

.modal-body
  grid-area: section1
  grid-row: 2 / 4

.signUpForm
  display: grid
  grid-column: 2 / 3
  padding: 10px

.actionSection
  padding: 5px


.modal-footer
  text-align: center !important
  grid-row: 5
  grid-area: section2

.modal-default-button
  float: right

.benefits
  align-content: left

.error
  color: red
  font-size: 15px

ul
  padding: 0
  list-style-type: none

p
  margin: 0px 0px 5px 5px

label, input[type=text]
  margin: 5px 5px 5px 5px
  padding: 5px
  width: 90%

.privacy checkbox
  width: 30%

.entryLevel
  padding: 5px
  margin: 5px

span
  padding-bottom: 8px

button
  width: 200px

.twitter_sign_up
  width: 200px
  margin: 5px
  background-color: #1da1f2
  font-size: 15px
  color: #ffffff
  border-radius: 5px
  text-align: center
  align-items: bottom

.twitter_icon
  vertical-align: bottom
  color: #ffffff

.signup_button
  width: 100px
  margin-bottom: 15px
</style>
